import { ButtonGroup, Button, useDisclosure, Menu, MenuButton, MenuList, MenuItem, MenuGroup, Box } from "@chakra-ui/react";
import LogosNotification from "utils/notification-utils";
import EditLessonGroupDialog from "../lesson-groups/edit-dialog";
import ConfirmDialog from "components/confirm-dialog";
import { useState } from "react";
import ProgramService from "../../../services/programs/program-service";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";

interface ProgramLessonProps {
    program: any,
    lessonGroup: any
};

const ToolbarLessonGroup: React.FC<ProgramLessonProps> = ({ program, lessonGroup }) => {
    const navigate = useNavigate();
    const { isOpen: isShowEditLessonGroupDialog, onOpen: onShowEditLessonGroupDialog, onClose: onCloseEditLessonGroupDialog } = useDisclosure();
    const { isOpen: isShowDeleteLessonGroupDialog, onOpen: onShowDeleteLessonGroupDialog, onClose: onCloseDeleteLessonGroupDialog } = useDisclosure();
    const [isDeleting, setIsDeleting] = useState<boolean>(false);

    const handleDeleteLessonGroup = () => {
        setIsDeleting(true);
        ProgramService.DeleteLessonGroup(program.id, lessonGroup.id).then((res: any) => {
            onCloseDeleteLessonGroupDialog();
            LogosNotification.Success("Lesson Group berhasil dihapus.");
            window.location.reload();
        }).catch((error: any) => {
            console.log(error);
        }).finally(() => {
            setIsDeleting(false);
        });
    };

    return (
        <Box mr={4}>
            <Menu>
                <MenuButton as={Button} rightIcon={<ChevronDownIcon />} size={"xs"} variant={"solid"} colorScheme={'green'}>
                    Actions
                </MenuButton>
                <MenuList color={'blackAlpha.700'}>
                    <MenuGroup fontWeight={'bold'} title='Lesson Group'>
                        <MenuItem onClick={onShowEditLessonGroupDialog}>Ubah Group</MenuItem>
                        <MenuItem onClick={onShowDeleteLessonGroupDialog}>Delete Group</MenuItem>
                    </MenuGroup>
                    <MenuGroup fontWeight={'bold'} title='Lesson'>
                        <MenuItem onClick={() => { navigate(`/programs/${program.id}/lessongroups/${lessonGroup.id}/new`) }}>Tambah Lesson Baru</MenuItem>
                    </MenuGroup>
                </MenuList>
            </Menu>
            {
                isShowEditLessonGroupDialog &&
                <EditLessonGroupDialog
                    program={program}
                    lessonGroup={lessonGroup}
                    onClose={onCloseEditLessonGroupDialog}
                    onRefreshData={(program: any) => {
                        onCloseEditLessonGroupDialog();
                        LogosNotification.Success("Lesson Group berhasil di perbaharui.")
                        window.location.reload();
                    }}
                />
            }
            {
                isShowDeleteLessonGroupDialog &&
                <ConfirmDialog
                    title={'Hapus Lesson Group'}
                    message={`Apakah Anda yakin untuk menghapus Lesson Group ${lessonGroup.title}?`}
                    colorScheme={'red'}
                    buttonLabel={'Hapus'}
                    onSubmit={handleDeleteLessonGroup}
                    onClose={onCloseDeleteLessonGroupDialog}
                    isLoading={isDeleting}
                />
            }
        </Box>
    );
};

export default ToolbarLessonGroup;